<template>
    <!-- 容器 -->
    <div class="message-container">
        <el-row justify="center" style="margin-top:25px">
            <el-col :span="24">
                <el-card class="box-card" shadow="always" body-style="padding:60px 50px">
                    <template #header>
                        <div class="card-header">
                            <div>
                                <span>MessageList</span>
                            </div>
                        </div>
                    </template>
                    <el-scrollbar height="650px">
                        <div class="list">
                            <div v-for="item in messageList" :key="item.refId">
                                <div class="top">
                                    <div class="msgicon">
                                        <img src="./../../../public/img/msg.svg">
                                    </div>
                                    <div class="text" v-if="!item.readFlag">
                                        <el-badge is-dot class="item">
                                            {{ item.senderName }}
                                        </el-badge>
                                    </div>
                                    <div class="text" v-else>
                                        {{ item.senderName }}
                                    </div>
                                    <el-text class="text" type="info" size="small">
                                        ({{ item.sendTime }})
                                    </el-text>
                                </div>
                                <el-text class="bottom" :line-clamp="2">
                                    {{ item.msg }}
                                </el-text>
                                <br>
                                <el-text class="bottom view" type="primary" @click="viewDetail(item)">
                                    <el-icon>
                                        <View />
                                    </el-icon>
                                    look
                                </el-text>
                                <el-divider />
                            </div>
                        </div>
                    </el-scrollbar>
                </el-card>
            </el-col>
        </el-row>
        <!-- 隐藏层，显示消息内容 -->
        <el-dialog v-model="messageDialogVisible" title="Message" width="1000" center>
            <el-descriptions direction="vertical" :column="3" border>
                <el-descriptions-item label="SenderName" align="center">{{ messageViewDetailCur.senderName
                }}</el-descriptions-item>
                <el-descriptions-item label="ReceiverName" align="center">{{ $store.state.user.email
                }}</el-descriptions-item>
                <el-descriptions-item label="SendTime" align="center">
                    <el-tag size="small">{{ messageViewDetailCur.sendTime }}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="Content" :span="3" style="white-space: pre-line;">
                    <!-- <pre class="formatted-text">{{ messageViewDetailCur.msg }}</pre> -->
                    {{ messageViewDetailCur.msg }}
                </el-descriptions-item>
            </el-descriptions>
            <template #footer>
                <div class="dialog-footer" style="margin-top: 10px;">
                    <el-button @click="deleteMessage" type="danger" style="margin-right: 10px;">Delete</el-button>
                    <el-button type="primary" @click="messageDialogVisible = false">
                        Confirm
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";
import { useRouter } from "vue-router";
import { useStore } from "vuex"
import request from "../../network/request"
import { ElMessage } from 'element-plus'
import { ElNotification } from 'element-plus'
import { View } from '@element-plus/icons-vue'

const store = useStore()

const messageDialogVisible = ref(false)
const messageViewDetailCur = ref({})

// 刷新消息
const flush = () => {
    request.get("/message/flush").then((res) => {
        if (res.code == 200) {
            store.commit("setUnreadCount", res.data.unreadCount)
            if (res.data.lastCount > 0) {
                ElMessage.success({
                    message: `You have ${res.data.lastCount} new messages`,
                    type: 'success',
                })
            }
        }
    })
}

// 查看消息详细
const viewDetail = (payload) => {
    request.patch(`/message/${payload.refId}`).then((res) => {
        if (res.code == 200) {
            messageViewDetailCur.value = payload
            messageDialogVisible.value = true
            payload.readFlag = true
            flush()
            getMessageList()
        }
    })
}

// 删除消息信息
const deleteMessage = () => {
    request.delete(`/message/${messageViewDetailCur.value.refId}`).then((res) => {
        if (res.code == 200) {
            flush()
            getMessageList()
            messageDialogVisible.value = false
        }
    })
}

onMounted(() => {
    getMessageList()
})


// 获取消息列表
const getMessageList = () => {
    request.get("/message?pagenum=1&pagesize=10").then((res) => {
        if (res.code == 200) {
            messageList.value = res.data
        }
    })
}


const messageList = ref([])


</script>


<style lang="scss">
.message-container {
    .box-card {}

    .top {
        display: flex;
        align-items: center;
        font-size: 13px;
        margin-bottom: 20px;

        .msgicon {
            background-color: #007eff29;
            width: 35px;
            height: 35px;
            line-height: 35px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;

            img {
                width: 50%;
            }
        }

        .text {
            margin-left: 10px;
        }

    }

    .bottom {
        text-align: justify;
        // margin-left: 5px;
        line-height: 30px;
        margin-right: 10px;
    }

    .view {
        cursor: pointer;
    }
    .formatted-text{
        font-size: 14px;
        white-space: pre-wrap;
    }
}
</style>